import AllCompanies from '../containers/companies'
import CompaniesFilters from '../containers/companies/CompaniesFilters'
import { useI18N } from '../../libraries/i18n/hook'
import PageHeading from '../components/layout/PageHeading'

const CompaniesPage = () => {
  const { t } = useI18N()

  return (
    <div className='pb-8'>
      <PageHeading>{t('companies.title')}</PageHeading>
      <p className='mb-3 text-black font-light'>{t('companies.description')}</p>
      <CompaniesFilters />
      <AllCompanies />
    </div>
  )
}

export default CompaniesPage
